import React from 'react'
import { useSelector } from 'react-redux'
import { money } from '../../utils/helpers'
import { changeLineItem } from '../../utils/Cart.js'

const CartItems = () => {
  const { cart } = useSelector((state) => state.cart)

  return (
    <ul className='flex flex-col gap-6 pb-6 w-full'>
      {
        cart.items.map((item, index) =>
          <li className='w-full grid grid-cols-4 gap-3 lg:gap-4' key={`item-${index}`}>
            {
              item.image &&
              <div>
                <a className={`relative block w-full aspect-[3/4] before:content-[''] before:inset-px before:absolute before:border before:border-[rgba(67,69,72,0.25)] overflow-hidden before:z-1`} href={item.url}>
                  <img className='media-center' src={item.image} alt={item.title} loading='lazy' />
                </a>
              </div>
            }
            <div className={`flex flex-col justify-between ${item.image ? 'col-span-3' : 'col-span-4'}`}>
              <div>
                <div className='flex gap-6 text-base justify-between items-center'>
                  <a className='text-base uppercase no-underline hover:underline' href={item.url}>{item.product_title}</a>
                  <div className='text-sm leading-4 text-right'>
                    {money(item.final_line_price)}
                    {item.original_line_price > item.final_line_price && <br />}
                    {item.original_line_price > item.final_line_price && <span className='opacity-70 line-through'>{money(item.final_line_price)}</span>}
                  </div>
                </div>
                { item.variant_title != 'Default Title' && <div className='mt-1 text-sm leading-4 capitalize'>{item.variant_title}</div> }
              </div>
              <div className='flex items-center gap-6'>
                <div className='inline-flex items-center gap-3'>
                  <button className=''
                    onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': item.quantity - 1})}}>
                    –
                  </button>
                  <span className=''>{item.quantity}</span>
                  <button className=''
                    onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': item.quantity + 1})}}>
                    +
                  </button>
                </div>
                <button className='underline text-sm' 
                  onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': 0})}}>
                  {window.cartStrings.remove}
                </button>
              </div>
            </div>
            
          </li>
        )
      }
    </ul>
  )
}

export default CartItems